import { Building2, Package, Eye, Edit2, Trash2, ExternalLink } from 'lucide-react';

export const CompaniesList = ({
                                  companies,
                                  onView,
                                  onEdit,
                                  onDelete,
                                  onViewProducts,
                                  loading = false
                              }) => {
    const getScopeColor = (scope) => {
        const colors = {
            'INSURANCE': 'bg-blue-100 text-blue-800',
            'INVESTMENTS': 'bg-green-100 text-green-800',
            'BANKING': 'bg-purple-100 text-purple-800',
            'IT': 'bg-indigo-100 text-indigo-800',
            'HEALTHCARE': 'bg-red-100 text-red-800',
            'RETAIL': 'bg-yellow-100 text-yellow-800'
        };
        return colors[scope] || 'bg-gray-100 text-gray-800';
    };

    if (companies.length === 0 && !loading) {
        return (
            <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
                <Building2 className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                <p className="text-gray-600 mb-4">No companies found</p>
                <p className="text-sm text-gray-500">Try adjusting your filters or add a new company</p>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {companies.map((company) => (
                <div
                    key={company.id}
                    className="bg-white rounded-lg border border-gray-200 hover:shadow-lg transition-all duration-200"
                >
                    <div className="p-6">
                        <div className="flex items-start justify-between mb-4">
                            <div className="flex items-center gap-3">
                                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                                    <Building2 className="w-6 h-6 text-blue-600" />
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-900">{company.name}</h3>
                                    <p className="text-sm text-gray-500">Code: {company.code}</p>
                                </div>
                            </div>
                            <span className={`px-2 py-1 text-xs rounded-full ${
                                company.active
                                    ? 'bg-green-100 text-green-800'
                                    : 'bg-gray-100 text-gray-800'
                            }`}>
                                {company.active ? 'Active' : 'Inactive'}
                            </span>
                        </div>

                        <p className="text-sm text-gray-600 mb-3 line-clamp-2">
                            {company.description || 'No description available'}
                        </p>

                        <div className="flex items-center justify-between mb-4">
                            <span className={`px-2 py-1 text-xs rounded-full ${getScopeColor(company.businessScope)}`}>
                                {company.businessScope}
                            </span>
                            <button
                                onClick={() => onViewProducts(company)}
                                className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-700 transition"
                            >
                                <Package className="w-4 h-4" />
                                <span>{company.productCount || 0} products</span>
                                <ExternalLink className="w-3 h-3" />
                            </button>
                        </div>

                        <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                            <button
                                onClick={() => onView(company)}
                                className="text-sm text-gray-600 hover:text-blue-600 transition flex items-center gap-1"
                            >
                                <Eye className="w-4 h-4" />
                                View Details
                            </button>
                            <div className="flex gap-2">
                                <button
                                    onClick={() => onEdit(company)}
                                    className="text-gray-400 hover:text-blue-600 transition"
                                    title="Edit Company"
                                >
                                    <Edit2 className="w-4 h-4" />
                                </button>
                                <button
                                    onClick={() => onDelete(company)}
                                    className="text-gray-400 hover:text-red-600 transition"
                                    title="Delete Company"
                                >
                                    <Trash2 className="w-4 h-4" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CompaniesList;
